import React from "react";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";

export default function HomeWhatWeDo(){
  const btnStyle={
    mt: 2,
    textTransform: "none",
    color: "gold",
    backgroundColor: "maroon",
    "&:hover": {
      color: "maroon",
      backgroundColor: "gold",
    },
  }
    return<Box sx={{ bgcolor: "rgba(128, 128, 128, 0.1)", borderRadius: 5 }}>
    <Box
      sx={{
        fontSize: 24,
        fontFamily: "roboto",
        fontWeight: "bold",
        pl: 2,
        pt: 6,
        mb: 4,
        width: "100%",
        justifyContent: "flex-start",
      }}
    >
      What we do
    </Box>
    {/* What we do section body */}
    <Stack
      direction={{ xs: "column", sm: "column", md: "row" }}
      alignItems="center"
      justifyContent="center"
      spacing={8}
      sx={{
        pb: 4,
        mb: 4,
        borderTopRightRadius: 30,
        borderTopLeftRadius: 30,
        width: "100%",
        height: "100%",
        p: 2,
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "column", md: "row" }}
        alignItems={{ xs: "flex-start", sm: "flex-start" }}
        spacing={3}
        sx={{ width: "100%" }}
      >
        <img
          src="/research.jpg"
          alt="Research"
          style={{
            width: "100%",
            height: 100,
            objectFit: "cover",
          }}
        />
        <Stack sx={{ width: "100%" }}>
          <Box sx={{ fontSize: 36, fontFamily: "roboto" }}>
            Policy <span style={{ color: "gold" }}>Research</span>
          </Box>
          {/* text-gray-600 */}
          <Box
            className="font-normal text-base leading-6 mt-4"
            style={{ fontFamily: "Open Sans", maxWidth: 300 }}
          >
            Policy Research Projects Aimed at assisting Policy Makers in STI
            Management Activities
          </Box>
          <Box sx={{mt:1}}>
            <Button
              sx={btnStyle}
            >
              <Link to="/research">Read More</Link>
            </Button>
          </Box>
          
        </Stack>
      </Stack>
      <Stack
        direction={{ xs: "column", sm: "column", md: "row" }}
        alignItems={{ xs: "flex-start", sm: "flex-start" }}
        spacing={3}
        sx={{ width: "100%" }}
      >
        <img
          src="/training.jpg"
          alt=""
          style={{
            width: "100%",
            height: 100,
            objectFit: "cover",
          }}
        />
        <Stack sx={{ width: "100%" }}>
          <Box sx={{ fontSize: 36, fontFamily: "roboto" }}>
            Capacity <span style={{ color: "gold" }}>Building</span>
          </Box>
          {/* text-gray-600 */}
          <Box
            className="font-normal text-base leading-6 mt-4"
            style={{ fontFamily: "Open Sans", maxWidth: 300 }}
          >
            Capacity Building Programmes Specifically Designed to Address
            Knowledge Gaps Existing Within the National Innovation System
          </Box>
          <Box sx={{mt:1}}>
            <Button
              sx={btnStyle}
            >
              <Link to="/capacity-building">Read More</Link>
            </Button>
          </Box>
          {/* </Stack> */}
        </Stack>
      </Stack>
    </Stack>
  </Box>
}